"use client"
import Link from 'next/link';
import styles from './StateHeader.module.scss';
import StateHeaderForm from './StateHeaderForm';
import StateHeaderBrochureBtn from './StateHeaderBrochureBtn';
import { useEffect, useRef } from 'react';
import useOnScreen from '@/helpers/Onscreen';

const imgUGCEntitled = "https://static.amityonline.com/_s/gyan_vigyan_a23375b79d_236cfec15d_8c9f0907df.svg";

const IconGloballyRecognised = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.90123 0.0276954C8.30782 0.0939019 7.40934 0.29608 6.8112 0.497984C5.50164 0.940039 4.33423 1.62486 3.27527 2.57221C2.87465 2.93061 2.27445 3.57164 2.30804 3.60523C2.31941 3.61661 2.64159 3.53578 3.02404 3.42558C3.58128 3.26505 3.89451 3.20134 4.60094 3.10499L5.4825 2.98474L5.89269 2.75784L6.30288 2.53099L6.76796 2.66516L7.23308 2.79933L7.93993 2.75866C8.32872 2.7363 8.66492 2.71224 8.68703 2.70521C8.70914 2.69817 8.8322 2.5234 8.96049 2.31677C9.22235 1.89509 9.19184 1.90912 9.66254 1.9934C9.89881 2.03571 10.058 2.0309 10.8328 1.95805L11.7295 1.87377L12.0047 1.57833C12.1561 1.4158 12.42 1.19012 12.5912 1.07679L12.9023 0.870704L13.3995 0.941016C13.7273 0.987396 13.9607 1.00116 14.0845 0.981491L14.2723 0.951614L13.9956 0.822291C13.3633 0.526884 12.3032 0.216812 11.4596 0.0805276C10.9933 0.00520945 9.39822 -0.0277178 8.90123 0.0276954ZM11.7714 0.626213L12.0727 0.798084L11.6062 1.1507L11.1398 1.50328L10.6926 1.54947L10.2454 1.59561L10.0627 1.48443C9.96214 1.42331 9.87932 1.36414 9.87866 1.35296C9.87573 1.30517 11.333 0.460677 11.4258 0.456376C11.4502 0.455242 11.6057 0.531655 11.7714 0.626213ZM7.62979 1.1755L7.84551 1.27103L8.12581 1.17561C8.27996 1.12309 8.41443 1.08852 8.42462 1.09873C8.51116 1.18531 8.73004 1.61012 8.69289 1.61927C8.66754 1.62549 8.36556 1.70577 8.02178 1.79767L7.39672 1.96473L7.09396 1.78794C6.92746 1.69068 6.7921 1.6016 6.79319 1.58994C6.79429 1.57833 6.92614 1.47536 7.08619 1.36109C7.24624 1.24686 7.37719 1.1369 7.37719 1.11668C7.37719 1.06569 7.38676 1.06795 7.62979 1.1755ZM12.1715 2.20445L12.1535 2.42916L12.6312 2.89843C13.1068 3.36563 13.5373 3.84409 13.5069 3.87174C13.4981 3.87976 13.3871 3.93845 13.2602 4.00223L13.0293 4.11818L12.8109 4.04889C12.6908 4.0108 12.4694 3.9286 12.319 3.86626L12.0456 3.7529L12.0341 3.49507L12.0226 3.2372L11.702 3.10287C11.2176 2.89991 11.2119 2.89882 11.1858 3.00374C11.1735 3.05337 11.1135 3.31029 11.0526 3.57473C10.9916 3.83912 10.9345 4.06281 10.9255 4.0718C10.9165 4.08076 10.7342 4.12624 10.5203 4.17282C10.3063 4.21943 10.1272 4.26096 10.1221 4.26511C10.117 4.26925 10.1323 4.42372 10.1561 4.60838L10.1994 4.9441L10.7289 5.04656C11.0776 5.11402 11.2669 5.13525 11.2832 5.10882C11.2969 5.08672 11.3402 4.8707 11.3795 4.62879C11.4188 4.38684 11.465 4.17332 11.4821 4.15424C11.5002 4.13414 11.6746 4.14016 11.8966 4.16851C12.2012 4.20739 12.3294 4.24465 12.5207 4.34985C12.7382 4.46947 12.7918 4.48222 13.0771 4.48222H13.3927L13.6112 4.92216C13.8217 5.3458 13.852 5.38455 14.429 5.96825L15.0282 6.57439L14.9877 6.80195L14.9473 7.02951L14.8051 7.00777C14.7269 6.9958 14.5096 6.96659 14.3221 6.94285L13.9813 6.89972L13.1556 7.32363L12.33 7.74757L11.7321 8.46529C11.1436 9.17174 11.1331 9.18769 11.0608 9.48204L10.9873 9.78109L10.7751 9.79321C10.5913 9.80373 10.5095 9.78085 10.1623 9.62185L9.76158 9.43836L9.37025 9.62627C9.155 9.72958 8.97889 9.82215 8.97889 9.83189C8.97889 9.87987 9.14773 10.5693 9.16938 10.6098C9.18508 10.6392 9.25224 10.5855 9.35029 10.4651L9.50628 10.2738L9.79927 10.2718L10.0923 10.2698V10.6291V10.9885L10.3267 11.0579C10.4773 11.1024 10.5944 11.1662 10.6543 11.2363C10.7055 11.2963 10.8165 11.4209 10.9009 11.5133L11.0542 11.6812L11.4538 11.5675L11.8534 11.4537L12.3204 11.528C12.5772 11.5689 13.0131 11.6636 13.2891 11.7385C13.6931 11.848 14.1756 11.9458 14.3367 11.9507C14.3506 11.9511 14.5592 12.1759 14.8001 12.4501L15.2381 12.9487L16.0835 13.4498C16.5484 13.7255 16.9397 13.963 16.9531 13.9777C16.9665 13.9925 16.7281 14.4797 16.4233 15.0604L15.8692 16.1163L15.2775 16.39L14.6859 16.6637L14.4581 17.28L14.2304 17.8963L13.3726 18.4728L12.5148 19.0492L12.4234 19.375C12.3731 19.5542 12.3384 19.7073 12.3463 19.7153C12.3705 19.7394 13.1142 19.5118 13.5699 19.3407C14.4358 19.0157 15.6686 18.305 16.3037 17.7647C17.6991 16.5777 18.6329 15.3169 19.2626 13.7699C20.4454 10.8639 20.1947 7.56127 18.5868 4.86937C18.3152 4.41476 18.3094 4.40835 18.2059 4.4489C18.1119 4.48574 16.7729 4.63493 16.5123 4.63759C16.4243 4.63849 16.3744 4.69261 16.1865 4.9906C16.0645 5.18418 15.9393 5.34256 15.9083 5.34256C15.7626 5.34256 15.5542 5.19266 14.9853 4.67889C14.396 4.14665 14.3674 4.11392 14.3068 3.90189C14.272 3.78015 14.1821 3.51337 14.107 3.30904C13.9873 2.98325 13.9434 2.91196 13.7503 2.72961C13.1822 2.19327 13.1648 2.18232 12.7449 2.09742C12.5322 2.05436 12.3202 2.01029 12.2738 1.99946C12.1964 1.98135 12.188 1.99809 12.1715 2.20445ZM1.67357 4.86077C1.53391 4.89307 1.38996 4.94872 1.35366 4.98438C1.24151 5.09474 0.792756 6.03978 0.598716 6.57439C0.376509 7.18656 0.182899 7.93919 0.0906642 8.54925C0.00112521 9.14139 -0.0281742 10.2972 0.0303856 10.9265C0.314824 13.9824 1.9793 16.7284 4.57211 18.4193C5.65505 19.1255 6.98938 19.645 8.31477 19.8763C8.75102 19.9525 9.0698 19.9799 9.70161 19.9954C10.4457 20.0138 11.1728 19.975 11.2339 19.9138C11.247 19.9007 11.2362 19.6206 11.21 19.2913L11.1622 18.6926L11.3793 17.8261C11.4986 17.3496 11.5963 16.9122 11.5963 16.8543C11.5963 16.7963 11.4983 16.4062 11.3786 15.9873C11.1765 15.2801 11.1357 15.1793 10.8077 14.576C10.6134 14.2187 10.4535 13.9066 10.4524 13.8826C10.4513 13.8585 10.5951 13.5355 10.772 13.1649C10.9489 12.7943 11.0865 12.484 11.0778 12.4753C11.0692 12.4666 10.9151 12.4155 10.7354 12.3617C10.4176 12.2664 10.3979 12.2533 10.0161 11.8808L9.62348 11.4978L8.84216 11.3271C8.41244 11.2333 8.046 11.1437 8.02783 11.1279C8.00967 11.1122 7.87344 10.8471 7.72507 10.5387L7.45532 9.97814V10.3195V10.661L7.32836 10.66C7.20804 10.6591 7.16424 10.6086 6.48969 9.69216L5.77803 8.72523L5.77674 7.92136L5.77549 7.11754L5.26173 6.27891C4.97917 5.81769 4.7436 5.43477 4.73833 5.428C4.73302 5.42124 4.32697 5.48725 3.83595 5.57469C3.10647 5.7046 2.85391 5.73365 2.45489 5.73354L1.96657 5.73342L1.68072 5.54297L1.39488 5.35257L1.72956 5.08704C1.91363 4.94101 2.06423 4.8156 2.06423 4.80833C2.06423 4.78357 1.92813 4.80184 1.67357 4.86077Z" fill="#1A325D" />
  </svg>
);

const IconDuration = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.55771 0.0190644C5.56615 0.139803 3.74363 0.955154 2.34196 2.35241C1.15135 3.53923 0.397896 4.99249 0.0965661 6.68314C0.00490255 7.19745 -0.029248 8.26262 0.0281249 8.81677C0.40301 12.4368 3.11786 15.3029 6.75645 15.9199C7.20643 15.9962 8.39052 16.0263 8.85928 15.9733C11.6465 15.6582 14.0075 14.0175 15.2185 11.5539C15.5857 10.8069 15.7984 10.1428 15.9343 9.31927C16.0244 8.7726 16.0227 8.6425 15.9237 8.49603C15.787 8.2938 15.6297 8.21087 15.4152 8.22805C15.0659 8.25599 14.9333 8.42065 14.8641 8.9125C14.6928 10.1295 14.2242 11.2536 13.4865 12.2173C13.2454 12.5324 12.6244 13.1577 12.3081 13.4041C11.4186 14.097 10.3795 14.5687 9.26082 14.7875C8.89448 14.8591 8.73704 14.8698 8.0349 14.8703C7.1962 14.8709 6.99259 14.8495 6.37116 14.6956C5.46486 14.4711 4.63288 14.0836 3.91439 13.5513C2.83407 12.7509 2.03068 11.6938 1.54886 10.4387C1.0615 9.16931 0.979086 7.62513 1.32711 6.28395C2.01029 3.65113 4.09249 1.74865 6.87904 1.21119C7.33788 1.12268 8.66453 1.1238 9.16359 1.21308C9.36411 1.24897 9.5687 1.26688 9.62852 1.25375C9.75896 1.22519 9.92852 1.08776 9.99763 0.95456C10.1216 0.715632 10.0125 0.363961 9.77332 0.231177C9.61991 0.145983 9.07518 0.0559353 8.55557 0.0299231C8.34625 0.0194484 8.1356 0.00666928 8.08744 0.00157159C8.03928 -0.00356101 7.80089 0.00429506 7.55771 0.0190644ZM10.6507 0.631625C10.3308 0.78871 10.2319 1.21391 10.4539 1.47697C10.5057 1.53831 10.7068 1.65954 10.9508 1.77651C11.1763 1.88457 11.5187 2.07043 11.7118 2.18949C12.0239 2.38191 12.0831 2.40597 12.2442 2.40597C12.5394 2.40597 12.781 2.16896 12.781 1.87934C12.781 1.57421 12.6941 1.47634 12.12 1.13448C11.6096 0.830609 11.0417 0.572652 10.8854 0.5737C10.8203 0.574119 10.7146 0.600201 10.6507 0.631625ZM7.49018 2.07574C5.98493 2.20957 4.5016 2.95743 3.53635 4.06907C1.16378 6.8015 1.68378 10.9026 4.66044 12.935C7.38114 14.7925 11.1453 14.0619 12.9793 11.3204C14.3243 9.30974 14.3275 6.70664 12.9874 4.7104C11.962 3.18305 10.3554 2.23851 8.50524 2.07528C8.06408 2.03635 7.93238 2.03642 7.49018 2.07574ZM13.1453 2.31536C12.9595 2.39948 12.8441 2.5633 12.824 2.77126C12.8038 2.9812 12.8486 3.0664 13.1642 3.41852C13.3019 3.57215 13.5153 3.83957 13.6386 4.01282C13.9112 4.39595 13.9831 4.4647 14.1688 4.51924C14.2827 4.55272 14.3418 4.55251 14.449 4.51826C14.7083 4.43541 14.8475 4.2433 14.8475 3.96827C14.8475 3.77494 14.7746 3.643 14.3993 3.15666C13.7406 2.30321 13.5115 2.14955 13.1453 2.31536ZM8.32496 3.82651C8.38818 3.86523 8.47091 3.95755 8.50884 4.03168C8.57476 4.16052 8.57781 4.2447 8.57781 5.94795V7.72946L9.98733 8.78625C10.8202 9.41065 11.4292 9.89154 11.4759 9.96165C11.7716 10.4051 11.2378 10.9878 10.7644 10.7385C10.6887 10.6986 9.9412 10.1509 9.1032 9.52126C7.94415 8.65046 7.56492 8.34732 7.51834 8.25434C7.46219 8.1423 7.45708 7.96709 7.45704 6.14928C7.45697 4.26034 7.46016 4.16017 7.52447 4.03454C7.60611 3.87505 7.66124 3.82672 7.83319 3.76408C7.98996 3.70693 8.16639 3.72934 8.32496 3.82651ZM14.7068 4.82751C14.5585 4.90621 14.4285 5.12045 14.4277 5.28766C14.4274 5.35554 14.4806 5.56765 14.5459 5.75906C14.6112 5.95043 14.6998 6.25629 14.7429 6.43873C14.786 6.62116 14.8347 6.82598 14.8512 6.89386C14.9146 7.15492 15.2256 7.33735 15.5015 7.27534C15.8049 7.20712 15.9473 6.99385 15.9202 6.64822C15.8857 6.20884 15.5484 5.10429 15.4005 4.9464C15.2212 4.75503 14.9357 4.70611 14.7068 4.82751Z" fill="#1A325D" />
  </svg>
);
const imgWasc = "https://static.amityonline.com/_s/WASC_new_logo_1_d7a81ca9c3.webp";
const imgTHE = "https://static.amityonline.com/_s/time_higher_4dc22e0102_eadc349810_39f3ddfb1e.svg";
const imgQAA = "https://static.amityonline.com/_s/QAA_969cfb1176_4878744baf_7219ffe85a.svg";
const imgWES1 = "https://static.amityonline.com/_s/WES_a8acc287ac_23565ae383_3a1573a50f.svg";
const imgWES2 = "https://static.amityonline.com/_s/79187571_f2c4_46bd_b536_c9806bcea054_8eeef92f4e.webp";

interface HeroSection {
  HeadingCk?: string;
  Subheading?: string;
  SubtitleCk?: string;
  Duration?: string;
  Badge1Label?: string;
  Badge2Label?: string;
  OnlinePillLabel?: string;
  AccreditationsLabel?: string;
  RFIHeading?: string;
  CTAButtonLabel?: string;
  SeatsFilled?: string;
  ShowSeatsFilled?: boolean;
  
}

export default function StateHeader({
  associatedPrograms,
  heroSection,
  isStateHome,
  slug,
  PROGRAM_ID,
  isBanner
}: {
  associatedPrograms?: any;
  heroSection?: HeroSection;
  isStateHome?:boolean
  slug?:string
  PROGRAM_ID?: string;
  isBanner?: boolean
}) {
  if (!heroSection) return null;

  const {
    HeadingCk: heading,
    Subheading: subheading,
    SubtitleCk: subtitle,
    Duration: duration,
    Badge1Label: badge1Label = 'Globally Recognised',
    Badge2Label: badge2Label = 'UGC- entitled',
    OnlinePillLabel: onlinePillLabel = 'ONLINE MODE',
    AccreditationsLabel: accreditationsLabel = 'Global Accreditations',
    RFIHeading: rfiHeading,
    CTAButtonLabel: ctaButtonLabel,
    SeatsFilled: seatsFilled,
    ShowSeatsFilled: showSeatsFilled = false,
  } = heroSection;
  const ref = useRef(null);
  const onScreen = useOnScreen(ref);

    useEffect(() => {
      const callIcon = document.getElementById("call-icon");
      const whatsapp = document.getElementById("whatts-app-journey");
      const chatButtonIcon = document.getElementById("chat-launcher-btn");
      const enrollNowRef = document.getElementById("enroll-now-cta");
  
      if (callIcon) {
        if (onScreen) {
          callIcon.style.display = "none";
        } else {
          callIcon.style.display = "block";
        }
      }
  
      if (whatsapp) {
        if (onScreen) {
          whatsapp.style.display = "none";
        } else {
          whatsapp.style.display = "block";
        }
      }
  
      if (chatButtonIcon) {
        if (onScreen) {
          chatButtonIcon.style.display = "none";
        } else {
          chatButtonIcon.style.display = "block";
        }
      }
  
      if (enrollNowRef) {
        if (onScreen) {
          enrollNowRef.style.display = "none";
        } else {
          enrollNowRef.style.display = "block";
        }
      }
    }, [onScreen]);
  return (
    <section className={styles.section}>
      <div className={styles.container}>


        {/* ─── Left content ─── */}
        <div className={styles.left} ref={ref}>

          {/* Globally Recognised + UGC badges */}
          {isStateHome ? <>
        <div className='flex gap-1 sm:hidden items-center'>
        <Link href='/' className='text-[#9E9E9E] text-sm font-medium capitalize'>Home</Link>
<span className='text-[#9E9E9E] text-sm font-medium'>&gt;</span>
<span className='text-[#1a325b] text-sm font-semibold capitalize'> {slug}</span>
        </div>
          </> :  <div className={styles.badgeRow}>
            {badge1Label && <div className={styles.badge}>
              <IconGloballyRecognised />
              <span>{badge1Label}</span>
            </div>}
            
            <div className={styles.badgeDivider} />
            {badge2Label && 
            <div className={styles.badge}>
              <img
                src={imgUGCEntitled}
                alt={badge2Label}
                className={styles.badgeIcon}
                width={23}
                height={20}
              />
              <span>{badge2Label}</span></div>
            }
          </div>}
         

          {/* ONLINE MODE pill */}
          {onlinePillLabel && 
          <div className={styles.onlinePill}>
            <span className={styles.onlineDot} />
            <span className={styles.onlineText}>{onlinePillLabel}</span>
          </div>
          }

          {/* H1 */}
          <h1 className={`${isStateHome ? styles.homeHeading:styles.heading}`}
            dangerouslySetInnerHTML={{ __html: heading?.replace(/<\/?h1[^>]*>/gi, '') ?? '' }}
          />

          {/* Subtitle */}
          <div className={styles.subtitle} dangerouslySetInnerHTML={{__html:subtitle }} />

          {/* Duration */}
          {!isStateHome &&
          <div className={styles.duration}>
            <IconDuration />
            <span className={styles.durationText}>Duration : {duration}</span>
          </div>
}

          {/* CTA + Accreditations */}
          <div className={styles.actions}>
          {!isStateHome && <StateHeaderBrochureBtn associatedPrograms={associatedPrograms} />}

            <div className={styles.accreditationsStrip}>
              <span className={styles.accreditationsLabel}>{accreditationsLabel}</span>
              <div className={styles.accreditationsLogos}>
                <img src={imgWasc} alt="WASC Accreditation (USA)" className={styles.accLogo} style={{ width: '7.625rem' }} />
                <img src={imgTHE} alt="Times Higher Education" className={styles.accLogo} style={{ width: '3.875rem' }} />
                <img src={imgQAA} alt="QAA (UK) Accreditation" className={styles.accLogo} style={{ width: '4.5625rem' }} />
                <img src={imgWES1} alt="WES Recognition" className={styles.accLogo} style={{ width: '1.5625rem' }} />
                <img src={imgWES2} alt="WES Recognition" className={styles.accLogo} style={{ width: '1.5625rem' }} />
              </div>
            </div>
          </div>
        </div>

        {/* ─── Right form card ─── */}
        <StateHeaderForm
          associatedPrograms={associatedPrograms}
          rfiHeading={rfiHeading}
          PROGRAM_ID={PROGRAM_ID}
          ctaButtonLabel={ctaButtonLabel}
          seatsFilled={seatsFilled}
          showSeatsFilled={showSeatsFilled}
          isStateHome={isStateHome}
        />

        {/* Global Accreditations — mweb only, appears below form */}
      </div>
        <div className={`${styles.accreditationsStrip} ${styles.accreditationsMobile} ${!isBanner?"sm:mb-5":""}`} >
          <span className={styles.accreditationsLabel}>{accreditationsLabel}</span>
          <div className={styles.accreditationsLogos}>
            <img src={imgWasc} alt="WASC Accreditation (USA)" className={styles.accLogo} style={{ width: '7.625rem' }} />
            <img src={imgTHE} alt="Times Higher Education" className={styles.accLogo} style={{ width: '3.875rem' }} />
            <img src={imgQAA} alt="QAA (UK) Accreditation" className={styles.accLogo} style={{ width: '4.5625rem' }} />
            <img src={imgWES1} alt="WES Recognition" className={styles.accLogo} style={{ width: '1.5625rem' }} />
            <img src={imgWES2} alt="WES Recognition" className={styles.accLogo} style={{ width: '1.5625rem' }} />
          </div>
        </div>
    </section>
  );
}
